// @ts-nocheck
import React, { useContext, useState } from "react";
import "./SalaryPage.scss";
import { FilterArea, Barchart, Boxplot, DataTable, ContentNavigation, DataQualityLegend } from "@sia/style-guide";
import {
  generateHeaderRows,
  generateBoxplotTableHeader,
  generateNavigationItems,
  generateBarchartOptions,
  generateBoxPlotOptions,
  getBoxplotLegends,
} from "./helpers";
import { usePageRefresh } from "../tools";
import { parseBoxplotData, parseBoxplotTableData, parseSalaryChartData, parseSalaryTableData } from "./data/dataParsing";
import { MasterKeyContext } from "contexts/MasterKeyContext";
import { useBreakPoint } from "@sia/style-guide/dist/common/useBreakPoint";
export default function SalaryPage({ translate, filters, setFilters, data, selectedTab, setSelectedTab }) {
  const OVERHEADS_PAGE_TAB_INDEX = 3;

  const { isMasterKeyValid } = useContext(MasterKeyContext);
  const { isMobile } = useBreakPoint();
  usePageRefresh(selectedTab, OVERHEADS_PAGE_TAB_INDEX, setSelectedTab);

  const [selectedItem, setSelectedItem] = useState(0);

  let barchartData = parseSalaryChartData(data, translate, isMasterKeyValid);
  let barchartTableHeaderRows = generateHeaderRows(translate, null, isMasterKeyValid);
  let barchartTableDataRows = parseSalaryTableData(data, isMasterKeyValid, translate);

  let boxplotProps = parseBoxplotData(data, isMasterKeyValid);

  let boxplotTableHeadersRows = generateBoxplotTableHeader(translate, isMasterKeyValid);
  let boxplotTableDataRows = parseBoxplotTableData(data, isMasterKeyValid, translate);

  const navigationItems = generateNavigationItems(translate, setSelectedItem);
  const barchartOptions = generateBarchartOptions(translate, isMobile);
  const boxplotOptions = generateBoxPlotOptions(translate, isMobile);
  const boxplotLegends = getBoxplotLegends(translate, isMasterKeyValid);

  return (
    <div className="benchmarking-salary-container sia-padding-02-left sia-padding-02-right sia-padding-04-top">
      <FilterArea
        translate={translate}
        initialFilters={filters}
        onFiltersUpdate={(filterAreaState) => {
          setFilters((state) => ({ ...state, filters: filterAreaState, newest: true }));
        }}
      />
      <div className="sia-padding-05-top sia-padding-05-bottom">
        <ContentNavigation preselectedItemIndex={selectedItem} items={navigationItems} />
      </div>
      {selectedItem === 0 ? (
        <React.Fragment>
          <Barchart data={barchartData} bandWidth={50} translate={translate} options={barchartOptions} />
          <div className="sia-padding-05-top sia-barchart-table">
            <DataTable headerRows={barchartTableHeaderRows} dataRows={barchartTableDataRows} />
          </div>
          <DataQualityLegend translate={translate} />
        </React.Fragment>
      ) : (
        <div>
          <Boxplot data={boxplotProps.data} ownValues={boxplotProps.ownValues} bandWidth={50} options={boxplotOptions} legends={boxplotLegends} />
          <div className="sia-padding-05-top sia-boxplot-table">
            <DataTable headerRows={boxplotTableHeadersRows} dataRows={boxplotTableDataRows} />
          </div>
          <DataQualityLegend translate={translate} />
        </div>
      )}
    </div>
  );
}
